import { render } from "./PriceSection.vue?vue&type=template&id=d0fab4be&ts=true"
import script from "./PriceSection.vue?vue&type=script&lang=ts"
export * from "./PriceSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__